import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './styles/index.css'
import { initTelegramWebApp } from './config/telegram'

// Инициализация Telegram Web App если приложение запущено в Telegram
if (typeof window !== 'undefined') {
  console.log('[main.tsx] Initializing app...')
  console.log('[main.tsx] Telegram WebApp available:', !!window.Telegram?.WebApp)
  
  const webApp = initTelegramWebApp();
  if (webApp) {
    console.log('[main.tsx] Telegram WebApp initialized:', {
      initData: webApp.initData ? 'present' : 'missing',
      user: webApp.initDataUnsafe?.user ? 'present' : 'missing',
      colorScheme: webApp.colorScheme,
    })
  } else {
    console.log('[main.tsx] Not running in Telegram Mini App')
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 минут
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
